import React from "react";
import { Link } from "react-router-dom";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { RESOURCES } from "../data/site";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }];

const Resources = () => (
  <>
    <Seo
      title="Custom Home Building Resources & Guides | Build Highland Homes"
      description="Helpful guides on custom home building, design, and building on your own land in Central Florida from Build Highland Homes."
      path="/resources"
      keywords="custom home building guide, how custom home building works, building on your own land, custom home design tips"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="Resources" title="Custom Home Building Guides" subtitle="Straightforward, factual answers to the most common questions about designing and building a custom home in Central Florida." image={IMAGES.blueprint} />

    <Section className="bg-[#0b0b0b]">
      <div className="grid md:grid-cols-3 gap-6">
        {RESOURCES.map((r) => (
          <Link key={r.slug} to={`/resources/${r.slug}`} className="group bg-[#141414] border border-[#c9a24b]/15 p-7 hover:border-[#c9a24b]/40 transition-colors">
            <span className="text-[#c9a24b] text-[10px] tracking-[0.2em] uppercase">{r.category}</span>
            <h2 className="font-serif-display text-2xl text-[#f3ede0] mt-2 mb-3 group-hover:text-[#e3c77a] transition-colors">{r.title}</h2>
            <p className="text-[#a39d90] text-sm leading-relaxed">{r.excerpt}</p>
          </Link>
        ))}
      </div>
    </Section>

    <CTASection />
  </>
);

export default Resources;
